import ResourceList from "@/components/ResourceList";

/**
 * Sites — mirrors the mobile app's Owner Sites screen.
 *
 * Backend contract (production Pit Link OpenAPI):
 *   GET  /api/admin/sites
 *   POST /api/admin/sites            body: { code*, company*, site_name*, address?, notes? }
 *   PATCH/DELETE /api/admin/sites/{code}
 */
export default function AdminSites() {
  return (
    <ResourceList
      endpoint="/admin/sites"
      title="Sites"
      subtitle="Owner · Locations"
      resourceName="Site"
      itemLabel={(it) => it.site_name || it.name || it.code || "Site"}
      itemMeta={(it) => [
        { label: "Code", value: it.code },
        { label: "Company", value: it.company },
        { label: "Address", value: it.address },
        { label: "Users", value: it.user_count ?? it.users },
      ]}
      statusOf={(it) => it.status || (it.archived ? "archived" : "active")}
      searchFields={["site_name", "name", "code", "company", "address"]}
      testid="admin-sites-page"
      emptyLabel="No sites configured yet."
      createConfig={{
        endpoint: "/admin/sites",
        singular: "Site",
        title: "Add Site",
        roles: ["admin", "control", "owner"],
        fields: [
          { name: "code", label: "Site Code", required: true, placeholder: "NP-01", hint: "Short unique code · used in URLs" },
          { name: "company", label: "Company / Operator", required: true, placeholder: "Rio Tinto" },
          { name: "site_name", label: "Site Name", required: true, placeholder: "Northern Pit" },
          { name: "address", label: "Address", placeholder: "Karratha WA 6714" },
          { name: "notes", label: "Notes", type: "textarea", rows: 2 },
        ],
      }}
    />
  );
}
